import {
  Dispatch,
  ReactElement,
  SetStateAction,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import { usePaymentOption } from "checkout-experience/hooks/use-payment-option";
import { PaymentType } from "checkout-query-client/types/form-types";

export type PaymentOption = {
  formId: string;
  paymentType: PaymentType;
};

type PaymentOptionContextType = {
  paymentOption: PaymentOption;
  setPaymentOption: Dispatch<SetStateAction<PaymentOption>>;
};

export const PaymentOptionContext =
  createContext<PaymentOptionContextType | null>(null);

type PaymentOptionProviderProps = {
  children: ReactElement;
};

export const PaymentOptionProvider = ({
  children,
}: PaymentOptionProviderProps) => {
  const paymentOptionValue = usePaymentOption();

  const [paymentOption, setPaymentOption] = useState<PaymentOption>({
    paymentType: paymentOptionValue?.paymentType ?? ("notSet" as PaymentType), //We always expect a value but this is used to prevent a submission if not MOP was selected
    formId: paymentOptionValue?.formId ?? "",
  });

  useEffect(() => {
    if (
      paymentOptionValue &&
      paymentOptionValue?.formId !== paymentOption.formId
    ) {
      setPaymentOption({
        formId: paymentOptionValue.formId,
        paymentType: paymentOptionValue.paymentType,
      });
    }
  }, [paymentOptionValue]);

  return (
    <PaymentOptionContext.Provider value={{ paymentOption, setPaymentOption }}>
      {children}
    </PaymentOptionContext.Provider>
  );
};

export const usePaymentOptionContext = () => {
  return useContext(PaymentOptionContext);
};
